import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Reassignment queue.
  requests: { items: [], loading: false, error: null, status: 'pending', total: 0, page: 1 },
  // id of the request currently being decided, so only its row shows a spinner.
  decidingId: null,
  decisionError: null,
  // Coaches available to hand a customer to, from the roster filtered by role.
  coaches: { items: [], loading: false, error: null },
};

const replaceRequest = (items, updated) => {
  const index = items.findIndex((request) => request.id === updated?.id);
  if (index >= 0) items[index] = { ...items[index], ...updated };
  return index >= 0;
};

const coachSlice = createSlice({
  name: 'coach',
  initialState,
  reducers: {
    setRequestStatusFilter: (state, action) => {
      state.requests.status = action.payload;
      state.requests.page = 1;
      state.requests.items = [];
      state.requests.loading = true;
      state.requests.error = null;
    },
    setRequestPage: (state, action) => {
      state.requests.page = action.payload;
      state.requests.items = [];
      state.requests.loading = true;
      state.requests.error = null;
    },
    getCoachRequestsAction: (state) => {
      state.requests.loading = true;
      state.requests.error = null;
    },
    getCoachRequestsSuccess: (state, action) => {
      state.requests.items = action.payload.items;
      state.requests.total = action.payload.total;
      state.requests.loading = false;
    },
    getCoachRequestsFailure: (state, action) => {
      state.requests.loading = false;
      state.requests.error = action.payload;
    },

    decideCoachRequestAction: (state, action) => {
      state.decidingId = action.payload.id;
      state.decisionError = null;
    },
    decideCoachRequestSuccess: (state, action) => {
      state.decidingId = null;
      state.decisionError = null;
      const updated = action.payload;
      // A decided request drops out of a pending-only view, but stays visible when the
      // filter would still include it, so the outcome is confirmed on screen.
      if (state.requests.status !== 'all' && updated.status !== state.requests.status) {
        state.requests.items = state.requests.items.filter((r) => r.id !== updated.id);
        state.requests.total = Math.max(0, state.requests.total - 1);
      } else {
        replaceRequest(state.requests.items, updated);
      }
    },
    decideCoachRequestFailure: (state, action) => {
      state.decidingId = null;
      state.decisionError = action.payload;
    },
    clearDecisionError: (state) => {
      state.decisionError = null;
    },

    getCoachesAction: (state) => {
      state.coaches.loading = true;
      state.coaches.error = null;
    },
    getCoachesSuccess: (state, action) => {
      state.coaches.items = action.payload;
      state.coaches.loading = false;
    },
    getCoachesFailure: (state, action) => {
      state.coaches.items = [];
      state.coaches.loading = false;
      state.coaches.error = action.payload;
    },
  },
});

export const {
  setRequestPage,
  setRequestStatusFilter,
  getCoachRequestsAction,
  getCoachRequestsSuccess,
  getCoachRequestsFailure,
  decideCoachRequestAction,
  decideCoachRequestSuccess,
  decideCoachRequestFailure,
  clearDecisionError,
  getCoachesAction,
  getCoachesSuccess,
  getCoachesFailure,
} = coachSlice.actions;

export { coachSlice };
